export const colors = {
  crimson: "#C62828",
  brown: "#5D4037",
  sage: "#849274",
  navy: "#1A237E",
  charcoal: "#2C2C2C",
  beige: "#F5F0E6",
  lavender: "#E8E4EF",
  cream: "#FFF8F0",
  gold: "#D4A017",
  white: "#FFFFFF",
  text: "#2C1810",
  muted: "#5C5346",
};

export const fonts = {
  display: '"Fraunces", "Palatino Linotype", Palatino, serif',
  body: '"Source Sans 3", "Segoe UI", sans-serif',
};
